var map = {
	"./boost.mp4": "6b1a",
	"./boost.webm": "7389",
	"./connect-your-apps.png": "b38a",
	"./create-free-account.png": "aef8",
	"./employees.mp4": "1d66",
	"./employees.webm": "54da",
	"./intelligent-forecasting.png": "168a",
	"./one-place.mp4": "607e",
	"./one-place.webm": "423c",
	"./save-time.mp4": "5970",
	"./save-time.webm": "93bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f9f4";